"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.BlueCheckBox = void 0;

var _react = _interopRequireDefault(require("react"));

var _check_box = _interopRequireDefault(require("../../asset/icons/check_box.svg"));

var _check_box_outline = _interopRequireDefault(require("../../asset/icons/check_box_outline.svg"));

require("./BlueCheckBox.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var BlueCheckBox = function BlueCheckBox(_ref) {
  var value = _ref.value,
      id = _ref.id,
      isChecked = _ref.isChecked,
      handleClick = _ref.handleClick;
  var svgPath = isChecked ? _check_box["default"] : _check_box_outline["default"];
  var altText = isChecked ? 'checked checkbox' : 'empty checkbox';

  var handleSpaceBar = function handleSpaceBar(e) {
    if (e.key === ' ') {
      e.preventDefault();
      handleClick();
    }
  };

  return /*#__PURE__*/_react["default"].createElement("li", {
    className: "lsn",
    onClick: handleClick,
    onKeyPress: function onKeyPress(e) {
      return handleSpaceBar(e);
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "fll"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    tabIndex: "0",
    className: "curp",
    src: svgPath,
    alt: altText
  }), /*#__PURE__*/_react["default"].createElement("input", {
    key: id,
    className: "dn",
    type: "checkbox",
    readOnly: true,
    checked: isChecked
  }), /*#__PURE__*/_react["default"].createElement("label", {
    className: "ml15"
  }, value)));
};

exports.BlueCheckBox = BlueCheckBox;
var _default = BlueCheckBox;
exports["default"] = _default;